'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Loader } from '@/shared/components/ui';
import { NotFoundState } from '@/shared/components/ui/common/NotFoundState';
import { FeatherArrowLeft, FeatherDownload } from '@subframe/core';
import type { CertificadoAcessosArbitral } from '../../types/certificadoAcessosTypes';
import { CertificadoAcessosDocumento } from './CertificadoAcessosDocumento';
interface CertificadoAcessosViewProps {
  certificado: CertificadoAcessosArbitral | null;
  isLoading: boolean;
  error: string | null;
  isDownloadingPdf: boolean;
  /** Ausente quando a pessoa não pode baixar (Secretaria sem `processos.baixar_documentos`). */
  onBaixarPdf?: () => void;
  onVoltar: () => void;
}
export function CertificadoAcessosView(t0) {
  const $ = _c(16);
  const {
    certificado,
    isLoading,
    error,
    isDownloadingPdf,
    onBaixarPdf,
    onVoltar
  } = t0;
  if (isLoading || !certificado && !error) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="flex h-64 w-full items-center justify-center"><Loader size="medium" /></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (error || !certificado) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <NotFoundState title={"Certificado n\xE3o encontrado"} description={"N\xE3o foi poss\xEDvel carregar o Certificado de Acessos deste processo. Tente novamente mais tarde."} />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeatherArrowLeft />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onVoltar) {
    t2 = <Button variant="neutral-tertiary" icon={t1} onClick={onVoltar}>Voltar</Button>;
    $[3] = onVoltar;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isDownloadingPdf || $[6] !== onBaixarPdf) {
    t3 = onBaixarPdf ? <Button icon={<FeatherDownload />} loading={isDownloadingPdf} disabled={isDownloadingPdf} onClick={onBaixarPdf}>Baixar PDF</Button> : null;
    $[5] = isDownloadingPdf;
    $[6] = onBaixarPdf;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="flex w-full max-w-[794px] items-center justify-between gap-3 pb-5" data-doc-print-hidden={true}>{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== certificado) {
    t5 = <div className="w-full max-w-full overflow-x-auto"><div data-doc-print-root={true} className="mx-auto flex w-fit flex-col gap-6 pb-6"><CertificadoAcessosDocumento certificado={certificado} /></div></div>;
    $[11] = certificado;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <div className="flex w-full flex-col items-center bg-neutral-100 px-4 py-6 sm:py-10">{t4}{t5}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}